// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as QuoteRouteImport } from './routes/quote'
import { Route as ProcessRouteImport } from './routes/process'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OurWorkRouteImport } from './routes/our-work'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AboutRouteImport } from './routes/about'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServicesSlugRouteImport } from './routes/services_.$slug'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const QuoteRoute = QuoteRouteImport.update({
            id: '/quote',path: '/quote',getParentRoute: () => rootRouteImport
          })
const ProcessRoute = ProcessRouteImport.update({
            id: '/process',path: '/process',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const OurWorkRoute = OurWorkRouteImport.update({
            id: '/our-work',path: '/our-work',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/services_/$slug',path: '/services/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AboutRoute: AboutRoute,ContactRoute: ContactRoute,OurWorkRoute: OurWorkRoute,PrivacyRoute: PrivacyRoute,ProcessRoute: ProcessRoute,QuoteRoute: QuoteRoute,ReviewsRoute: ReviewsRoute,ServicesRoute: ServicesRoute,TermsRoute: TermsRoute,ServicesSlugRoute: ServicesSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)